import axios from '../axios';
// entities
import { Follower } from 'entities/follow';
import { Pagination } from 'entities/pagination';

export default {
  getList: (queryString?: string): Promise<Pagination<Follower>> => axios.get(`followers?${queryString}`),
};
